import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Hamburger24 = ({
  height = 24,
  width = 24,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M3.75 6C3.33579 6 3 6.33579 3 6.75C3 7.16421 3.33579 7.5 3.75 7.5H20.2515C20.6657 7.5 21.0015 7.16421 21.0015 6.75C21.0015 6.33579 20.6657 6 20.2515 6H3.75ZM3 11.9983C3 11.5841 3.33579 11.2483 3.75 11.2483H20.2515C20.6657 11.2483 21.0015 11.5841 21.0015 11.9983C21.0015 12.4125 20.6657 12.7483 20.2515 12.7483H3.75C3.33579 12.7483 3 12.4125 3 11.9983ZM3 17.2466C3 16.8324 3.33579 16.4966 3.75 16.4966H20.2515C20.6657 16.4966 21.0015 16.8324 21.0015 17.2466C21.0015 17.6608 20.6657 17.9966 20.2515 17.9966H3.75C3.33579 17.9966 3 17.6608 3 17.2466Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
